import { ActionConfig, ActionContext } from '../../../logic/types'
import { ClaimSparkRewardsAction } from '../types'
import { sparkRewardsConfig } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { claimableRewardsQueryKey } from '@/features/spark-rewards/data/claimableRewardsQueryOptions'

export function createClaimSparkRewardsActionConfig(
  action: ClaimSparkRewardsAction,
  context: ActionContext,
): ActionConfig {
  const { account, chainId } = context
  const { epoch, token, cumulativeAmount, merkleRoot, merkleProof } = action

  return {
    getWriteConfig: () => {
      return ensureConfigTypes({
        address: getContractAddress(sparkRewardsConfig.address, chainId),
        abi: sparkRewardsConfig.abi,
        functionName: 'claim',
        args: [BigInt(epoch), account, token.address, token.toBigInt(cumulativeAmount), merkleRoot, merkleProof],
      })
    },

    invalidates: () => [getBalancesQueryKeyPrefix({ chainId, account }), claimableRewardsQueryKey({ account })],
  }
}
